import Store from 'app/redux/store'
import { AxiosResponse } from 'axios'
import Redux from 'app/interface/redux'
import { bindActions } from 'redux-zero/utils'
import { NestAPI } from '../../../../nestapi'
import { Pod } from '@marketing-milk/interfaces'

const Master = bindActions(
  store => ({
    init: async (): Promise<void> => {
      const result: AxiosResponse<Pod[]> = await NestAPI.get('pods')
      const state: Redux = store.getState()
      store.setState({
        data: {
          ...state.data,
          generic: {
            ...state.data.generic,
            pods: {
              data: result,
              loading: false,
              timestamp: +new Date(),
            },
          },
        },
      })
    },
  }),
  Store
)

export default Master
